module.exports = __webpack_public_path__ + "img/three-dot.98a63ad0.svg";